// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".DialogCard-module-content-31bTs{display:flex;flex-direction:column;width:100%;height:100%}@media(min-width: 960px){.DialogCard-module-content-31bTs{width:50%;border:1px solid rgba(151,151,151,.33);border-radius:8px;box-sizing:border-box;margin-inline-start:32px;padding:15px}}", ""]);
// Exports
exports.locals = {
	"content": "DialogCard-module-content-31bTs"
};
module.exports = exports;
